export default function Game( { socket } ) {
	return <div>Waiting for host to select a game...</div>;
}